/* eslint-disable */
export default {
  close: '關閉',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
